import React from 'react';
import {useCart} from "../utilities/context/cart/cart-context";
import {Link} from "react-router-dom";

const CartItem = ({item}) => {

    const {addToCart, removeFromCart} = useCart();

    const handleRemove = () => {
        removeFromCart(item.id);
    }

    const handleAdd = () => {
        addToCart(item);
    }

    return (
        <div className="rounded p-1 flex flex-col items-center bg-white bg-opacity-10 mb-2">
            <div className="font-bold uppercase ">{item.name}</div>
            <div className="mb-1">Prezzo unitario: {item.price}€</div>

            {item.countable
                ? <div className="flex flex-row items-center">
                    <button className="p-1 bg-yellow-300 text-black rounded h-6 w-6 flex flex-row items-center justify-center" onClick={handleRemove}>-</button>
                    <div className="mx-2">{item.amount}</div>
                    <button className="p-1 bg-yellow-300 text-black rounded h-6 w-6 flex flex-row items-center justify-center" onClick={handleAdd}>+</button>
                </div>
                :
                <div>
                    <div className="p-1 bg-yellow-300 text-black rounded" onClick={handleRemove}>Rimuovi</div>
                </div>
            }
        </div>
    );
}

const Cart = ({...props}) => {

    const {cart, getTotal} = useCart();

    return (
        <div className="p-2">
            <div className="mb-4 text-lg uppercase font-bold">Carrello</div>
            <div>
                {cart && cart.length > 0 &&
                    cart.map((cartItem,i) => <CartItem key={i} item={cartItem} />)
                }
            </div>
            <div className="flex flex-row justify-between items-center">
                <div>TOTALE: <span className="font-bold text-yellow-300 text-xl">{getTotal()}€</span></div>
                {getTotal() > 0 &&
                    <Link to={"/buy"}>
                        <button className="bg-yellow-300 p-1 rounded text-black font-bold">ACQUISTA</button>
                    </Link>

                }
            </div>

        </div>
    )
}

export default Cart;